module.exports = __webpack_public_path__ + "static/media/certification.4a5bd0bc.pdf";